interface IconProps {
  color?: string
}

export const QuestionmarkCircle = ({ color }: IconProps) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24 12.8672C24 6.71842 19.016 1.73438 12.8672 1.73438C6.71842 1.73438 1.73438 6.71842 1.73438 12.8672C1.73438 19.016 6.71842 24 12.8672 24C19.016 24 24 19.016 24 12.8672ZM25.7344 12.8672C25.7344 19.9733 19.9733 25.7344 12.8672 25.7344C5.76112 25.7344 0 19.9733 0 12.8672C0 5.76112 5.76112 0 12.8672 0C19.9733 0 25.7344 5.76112 25.7344 12.8672Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M11.4273 15.3233C11.4273 14.6837 11.5906 14.1325 11.9172 13.6697C12.2438 13.207 12.727 12.683 13.3666 12.0978C13.9383 11.567 14.367 11.1043 14.6528 10.7096C14.9386 10.3013 15.0815 9.84539 15.0815 9.34183C15.0815 8.66134 14.8773 8.13736 14.469 7.7699C14.0607 7.38883 13.4823 7.19829 12.7338 7.19829C11.6923 7.19829 10.9417 7.64462 10.482 8.5373C10.235 9.01695 9.69859 9.32823 9.18995 9.14834C8.77234 9.00065 8.50909 8.56735 8.66986 8.1546C8.91272 7.53111 9.32149 7.00139 9.89615 6.56543C10.6855 5.9666 11.6518 5.66719 12.795 5.66719C13.5844 5.66719 14.2989 5.8169 14.9386 6.11631C15.5782 6.40212 16.0818 6.82402 16.4493 7.38202C16.8167 7.94002 17.0005 8.59329 17.0005 9.34183C17.0005 9.91344 16.8984 10.417 16.6942 10.8525C16.5037 11.288 16.2655 11.6555 15.9797 11.9549C15.7075 12.2543 15.3469 12.5878 14.8977 12.9552C14.3125 13.4452 13.877 13.8739 13.5912 14.2414C13.319 14.5952 13.1829 14.7653 13.1829 15.3233C13.1829 15.7405 12.8447 16.0787 12.4276 16.0787H12.1826C11.7654 16.0787 11.4273 15.7405 11.4273 15.3233Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5339 19.4672C13.5339 18.9149 13.0861 18.4672 12.5339 18.4672C11.9816 18.4672 11.5339 18.9149 11.5339 19.4672C11.5339 20.0195 11.9816 20.4672 12.5339 20.4672C13.0861 20.4672 13.5339 20.0195 13.5339 19.4672Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
